import React, { useEffect, useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import { useNavigate } from "react-router-dom";
import TabsNav from "../../components/TabsNav";
import LockIcon from "@mui/icons-material/Lock";
import { GridColDef, DataGrid } from "@mui/x-data-grid";
import SearchIcon from "../../images/icons/SearchIcon.svg";
import {
  BtnGroupStyle,
  ContentStyle,
  DataGridListStyle,
  LetterSearchStyle,
  SearchBox,
} from "../../Theme";
import { YSButton } from "../../uikit/YSButton";
import { DialogPopup } from "../../components/DialogPopup";
import ConfirmPopup from "../../components/ConfirmPopup";
import { useDispatch, useSelector } from "react-redux";
import { loadingAllFavDrugs } from "../../Redux/Slice/FavDrugsSlice";
import { v4 as uuid } from "uuid";
import YSSnackBar from "../../uikit/YSSnackBar";
import {
  ConfirmFavDrugsPrescription,
  FavDrugsAlphaColors,
  RemoveFavDrugsById,
} from "../../Apis/AuthApiServices";
import NoRecords from "../../components/NoRecords";
import {
  DrugTextNTooltip,
  TextNA,
  TextNTooltip,
  TextOnly,
} from "../../components/Content";
import useDebounce from "../../CustomHooks/useDebounce";
import ErrorOverlay from "../../components/ErrorOverlay";
import useFetch from "../../CustomHooks/useFetch";
import { useOnBehalfContext } from "../../context/OnbehalfContext";

export default function FavoriteDrugs() {
  const UserServiceState = useSelector((state: any) => {
    return { ...state?.UserServicesSlice?.ServicesData };
  }); //redux data
  const { onBehalfContext }: any = useOnBehalfContext();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [drugNameInput, setDrugNameInput] = useState("");
  const [sortByAlpha, setSortByAlpha] = useState("");
  const [selectionData, setSelectionData] = useState("");
  const [deleteFavDrugsPopup, setDeleteFavDrugsPopup] = React.useState(false);
  const [deleteStateData, setDeleteStateData] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });

  const columnsFavoriteDrugs: GridColDef[] = [
    {
      field: "description",
      headerName: "Drug Description",
      minWidth: 200,
      cellClassName: "w20",
      headerClassName: "w20",
      renderCell: ({ row }) => (
        <DrugTextNTooltip
          row={row}
          needPharmacy={true}
          onClick={() => {
            if (
              !row.obseletRx &&
              UserServiceState?.profileGroup !== 11 &&
              !row.freeTextRx &&
              (!sessionStorage.getItem("freeTextRxTabs") ||
                JSON.parse(sessionStorage.getItem("freeTextRxTabs")!)[0]
                  ?.drugName == "")
            ) {
              navigate("/newrxpad", {
                state: {
                  rowData: row,
                  key: "favDrugPop",
                },
              });
            } else if (
              row.freeTextRx &&
              (!sessionStorage.getItem("rxTabs") ||
                JSON.parse(sessionStorage.getItem("rxTabs")!)[0]?.drugName ==
                  "")
            ) {
              navigate("/freetextmedication", {
                state: {
                  rowData: row,
                  key: "FreeTextFavDrugPop",
                },
              });
            } else {
              setDeleteStateData((prevState: any) => {
                return {
                  ...prevState,
                  message:
                    "Please don't select the regular and free-text prescriptions together.",
                  variant: "error",
                  open: true,
                };
              });
            }
          }}
          color={UserServiceState?.profileGroup !== 11 ? "primary" : ""}
        />
      ),
    },
    {
      field: "sig",
      headerName: "SIG",
      minWidth: 170,
      cellClassName: "w20",
      headerClassName: "w20",
      renderCell: (params: any) => <TextNTooltip Text={params.value} />,
    },
    {
      field: "quantity",
      headerName: "Quantity",
      maxWidth: 70,
      cellClassName: "w10",
      headerClassName: "w10",
      align: "center",
      headerAlign: "center",
      renderCell: (params: any) => <TextOnly Text={params.value} />,
    },
    {
      field: "refills",
      headerName: "Refills",
      maxWidth: 70,
      cellClassName: "w10",
      headerClassName: "w10",
      align: "center",
      headerAlign: "center",
      renderCell: (params: any) => <TextOnly Text={params.value} />,
    },
    {
      field: "rxOtc",
      headerName: "Rx/OTC",
      maxWidth: 70,
      cellClassName: "w10",
      headerClassName: "w10",
      align: "center",
      headerAlign: "center",
      renderCell: (params: any) => <TextOnly Text={params.value} />,
    },
    {
      field: "formularyStatus",
      headerName: "Fmlry. Status",
      minWidth: 120,
      cellClassName: "w15",
      headerClassName: "w15",
      renderCell: (params: any) => <TextNA Text={params.value} />,
    },
    {
      field: "copay",
      headerName: "Copay",
      minWidth: 120,
      cellClassName: "w15",
      headerClassName: "w15",
      renderCell: (params: any) => <TextNA Text={params.value} />,
    },
  ];

  const handleShowDeletePopupClick = () => {
    setDeleteFavDrugsPopup(true);
  };
  const handleHideDeletePopupClick = () => {
    setDeleteFavDrugsPopup(false);
  };

  const debouncedValue = useDebounce(drugNameInput, 1000);

  const deleteRowData = async () => {
    try {
      const params = new URLSearchParams();
      params.append("favoriteDrugIds", selectionData);
      const result = await RemoveFavDrugsById(params);
      if (result?.data?.digitalRxStatusCode === 200) {
        setDeleteStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.response[0]?.message,
            variant: "success",
            open: true,
          };
        });
        getFavDrugs(page, debouncedValue);
      } else {
        setDeleteStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (err: any) {
      setDeleteStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Try Again After Some Time!",
          variant: "error",
          open: true,
        };
      });
    }
  };

  const Params = {
    doctorId:
      UserServiceState?.profileGroup > 6
        ? localStorage.getItem("SupervisorDoctorId")
        : localStorage.getItem("doctorId"),
  };
  const { data: AlphaColors }: any = useFetch(Params, FavDrugsAlphaColors, []);

  const prepareAlphabets = () => {
    let result = [];
    for (let i = 65; i < 91; i++) {
      result.push(
        <button
          className={String.fromCharCode(i) === sortByAlpha ? "active" : ""}
          disabled={
            AlphaColors[0]?.alphabetMap?.includes(String.fromCharCode(i))
              ? false
              : true
          }
          type="button"
          key={i}
          onClick={(e: any) => {
            setSortByAlpha(e.target.value);
          }}
          value={String.fromCharCode(i)}
        >
          {String.fromCharCode(i)}
        </button>
      );
    }
    result.push(
      <button
        className={sortByAlpha === "" ? "active" : ""}
        type="button"
        onClick={() => {
          setSortByAlpha("");
        }}
        value={""}
      >
        All
      </button>
    );
    return result;
  };

  const FavDrugsState = useSelector((state: any) => {
    return { ...state.FavDrugsSlice };
  }); //redux data
  const [rowCountState, setRowCountState] = useState(
    FavDrugsState?.Pagination?.totalItems || 0
  );
  const [superId, setSuperId] = useState("");
  useEffect(() => {
    const handleStorage = () => {
      const pId: any = localStorage.getItem("SupervisorDoctorId");
      setSuperId(pId);
    };

    window.addEventListener("storage", handleStorage);

    return () => window.removeEventListener("storage", handleStorage);
  }, []);
  const getFavDrugs = (nextPage: number, debouncedValueofDrugName: string) => {
    let payloadData = {
      pageNumber: nextPage,
      sortByAlpha: sortByAlpha,
      drugName: debouncedValueofDrugName,
      doctorId:
        UserServiceState?.profileGroup > 6
          ? localStorage.getItem("SupervisorDoctorId")
          : localStorage.getItem("doctorId"),
    };
    dispatch(loadingAllFavDrugs(payloadData));
  };

  useEffect(() => {
    getFavDrugs(page, debouncedValue);
  }, [sortByAlpha, debouncedValue, page, superId]);

  useEffect(() => {
    setRowCountState((prevRowCountState: any) =>
      FavDrugsState?.Pagination?.totalItems !== undefined
        ? FavDrugsState?.Pagination?.totalItems
        : prevRowCountState
    );
  }, [FavDrugsState?.Pagination?.totalItems, setRowCountState]);

  const patientId: any = sessionStorage.getItem("patientId");
  const [load, setLoad] = useState(false);
  const confirmFavDrugPresc = async () => {
    try {
      setLoad(true);
      const bodyData = {
        patientId: patientId,
        userDetails: {
          doctorId:
            UserServiceState?.profileGroup > 6
              ? localStorage.getItem("SupervisorDoctorId")
              : localStorage.getItem("doctorId"),
          onBehalfDoctorId: localStorage.getItem("onBehalf") ?? "",
          selectedClinicId: sessionStorage.getItem("clinicId"),
        },
        prescriptionIds: selectionData === "" ? null : selectionData,
      };
      const result: any = await ConfirmFavDrugsPrescription(bodyData);
      if (result?.data?.digitalRxStatusCode === 200) {
        if (result?.data?.response[0]?.popUpFlag?.freeText) {
          navigate("/freetextmedication/summary", {
            state: "confirmFreeTextFdList",
          });
          sessionStorage.setItem(
            "locationData",
            JSON.stringify(result?.data?.response[0])
          );
          sessionStorage.setItem(
            "freeTextRxTabs",
            JSON.stringify(result?.data?.response[0]?.prescriptionFormList)
          );
        } else {
          navigate("/newrxpad/summary", {
            state: "confirmFdList",
          });
          sessionStorage.setItem(
            "locationData",
            JSON.stringify(result?.data?.response[0])
          );
          sessionStorage.setItem(
            "rxTabs",
            JSON.stringify(result?.data?.response[0]?.prescriptionFormList)
          );
        }
        setLoad(false);
      } else {
        setDeleteStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
        setLoad(false);
      }
    } catch (er) {
      setDeleteStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Try Again Later!",
          variant: "error",
          open: true,
        };
      });
      setLoad(false);
    }
  };
  if (load)
    return (
      <Grid
        container
        justifyContent={"center"}
        display={"flex"}
        alignItems="center"
        height={"100vh"}
      >
        {" "}
        <CircularProgress color="primary" />
      </Grid>
    );
  return (
    <>
      <TabsNav />
      <ContentStyle>
        <LetterSearchStyle>{prepareAlphabets()}</LetterSearchStyle>
        <Grid
          container
          item
          xs={12}
          spacing={1}
          alignItems="top"
          justifyContent="flex-start"
          marginBottom={1}
        >
          <Grid item xs={12} md={7} textAlign={"left"}>
            <SearchBox className="searchicon">
              <Typography component="label" color="primary" variant="body2">
                Search by
              </Typography>{" "}
              <TextField
                id="drugname"
                name="DrugName"
                variant="outlined"
                placeholder="Enter Drug name"
                onChange={(e) => {
                  setDrugNameInput(e.target.value);
                }}
                style={{ borderRadius: 100 }}
                InputProps={{
                  endAdornment: (
                    <IconButton>
                      <img src={SearchIcon} alt="Search" loading="lazy" />
                    </IconButton>
                  ),
                }}
              />{" "}
            </SearchBox>
          </Grid>
        </Grid>
        <Grid
          container
          item
          xs={12}
          spacing={1}
          alignItems="top"
          justifyContent="center"
        >
          <Grid item xs={12}>
            <DataGridListStyle>
              <DataGrid
                rows={FavDrugsState?.Items ?? []}
                headerHeight={36}
                paginationMode="server"
                sortingOrder={["desc", "asc"]}
                columns={columnsFavoriteDrugs}
                autoHeight
                rowHeight={40}
                rowsPerPageOptions={[10]}
                disableSelectionOnClick
                checkboxSelection
                getRowId={(row) => row.personDrugId ?? uuid()}
                loading={FavDrugsState?.isLoading}
                components={{
                  NoRowsOverlay: NoRecords,
                  NoResultsOverlay: NoRecords,
                  ErrorOverlay: ErrorOverlay,
                }}
                error={FavDrugsState?.error || undefined}
                page={page}
                pageSize={pageSize}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                onPageChange={(newPage) => {
                  setPage(newPage);
                }}
                rowCount={rowCountState}
                onSelectionModelChange={(ids: any) => {
                  setSelectionData(ids);
                }}
                getRowClassName={(params) => {
                  if (params.row.freeTextRx) {
                    return "FTP";
                  } else if (params.row.obseletRx) {
                    return "OP";
                  }
                  return "";
                }}
              />
            </DataGridListStyle>
          </Grid>
          <Grid item xs={12}>
            <BtnGroupStyle className="middle">
              <YSButton
                onClick={handleShowDeletePopupClick}
                className=""
                children={"Delete"}
                size={"large"}
                type="button"
                color="primary"
                variant="outlined"
                disabled={
                  onBehalfContext?.id && UserServiceState?.profileGroup !== 11
                    ? false
                    : UserServiceState?.profileGroup > 6
                    ? true
                    : false
                }
                startIcon={
                  onBehalfContext?.id && UserServiceState?.profileGroup !== 11
                    ? null
                    : UserServiceState?.profileGroup > 6 && <LockIcon />
                }
              />{" "}
              <YSButton
                onClick={() => {
                  confirmFavDrugPresc();
                }}
                className=""
                children={"Confirm Prescription(s)"}
                disabled={
                  onBehalfContext?.id && UserServiceState?.profileGroup !== 11
                    ? false
                    : UserServiceState?.profileGroup > 9
                    ? true
                    : false
                }
                startIcon={
                  onBehalfContext?.id && UserServiceState?.profileGroup !== 11
                    ? null
                    : UserServiceState?.profileGroup > 9 && <LockIcon />
                }
                size={"large"}
                type="submit"
                color="primary"
                variant="contained"
              />{" "}
            </BtnGroupStyle>
          </Grid>
        </Grid>{" "}
        <YSSnackBar
          message={deleteStateData.message}
          variant={deleteStateData.variant}
          open={deleteStateData.open}
          handleClose={() => {
            setDeleteStateData((prevState: any) => {
              return { ...prevState, open: false };
            });
          }}
        />
      </ContentStyle>
      <DialogPopup
        windowsize={"sm"}
        show={deleteFavDrugsPopup}
        handleShowPopupClick={handleShowDeletePopupClick}
        handleHidePopupClick={handleHideDeletePopupClick}
        close={true}
      >
        <ConfirmPopup
          deleteRowData={deleteRowData}
          handleHideDeletePopupClick={handleHideDeletePopupClick}
        />
      </DialogPopup>
    </>
  );
}
